import axios from 'axios';
import {Card, Line} from 'ktm-ui';
import React from 'react';
import { Spinner } from 'react-bootstrap';
import {MdEmail} from 'react-icons/md';
import toastr from "toastr";
import ReactMoment from "react-moment";
import EmployeeCampaigns from './Employee_campaigns';

export default class Campaign extends React.Component<any, any> {

    constructor (props:any) {
        super(props);
        this.state = {
            loading: true,
            hasCampaign: false,
            SelectionDeadline: null,
            LaunchDate: null,
            ReminderDate: null,
            LastDayReminder: null,
        };

        this.getCampaign = this.getCampaign.bind(this);
    }

    componentDidMount() {
        this.setState({loading: true});
        this.getCampaign();
    }
    
    render(){
        
        let contents = null;
     
        if (this.state.loading) {
            contents = (
            <div className="pad-container">
                <Spinner
                className="pad-spinner"
                animation="border"
                variant="primary"
                />
            </div>
            );
        } else if (this.state.hasCampaign) {
            contents = (
                <div className="campaign-info-container">
                    <Card
                        label="Campaign Details"
                    >
                        <Line>
                            <div className='RT-Static-Field'>
                                <label className='RT-Static-Field__label'>Launch Date (YYYY-MM-DD)</label>
                                <div className='RT-Static-Field__content'  style={{height:"21px"}}>
                                    {this.state.LaunchDate  == null ? "" : <ReactMoment format="YYYY-MM-DD">{this.state.LaunchDate}</ReactMoment>}
                                </div>
                            </div>
                            <div className='RT-Static-Field'>
                                <label className='RT-Static-Field__label'>Reminder Date (YYYY-MM-DD)</label>
                                <div className='RT-Static-Field__content'  style={{height:"21px"}}>
                                    {this.state.ReminderDate  == null ? "" : <ReactMoment format="YYYY-MM-DD">{this.state.ReminderDate}</ReactMoment>} 
                                </div>
                            </div>
                            <div className='RT-Static-Field'>
                                <label className='RT-Static-Field__label'>Last Day Reminder (YYYY-MM-DD)</label>
                                <div className='RT-Static-Field__content'  style={{height:"21px"}}>
                                {this.state.LastDayReminder  == null ? "" : <ReactMoment format="YYYY-MM-DD">{this.state.LastDayReminder}</ReactMoment>}
                                </div>
                            </div>
                            <div className='RT-Static-Field'>
                                <label className='RT-Static-Field__label'>Selection Deadline (YYYY-MM-DD)</label>
                                <div className='RT-Static-Field__content' style={{height:"21px"}}>
                                    {this.state.SelectionDeadline  == null ? "": <ReactMoment format="YYYY-MM-DD">{this.state.SelectionDeadline}</ReactMoment>}
                                </div>
                            </div>
                        </Line>
                    </Card>
                    <div className="employee-campaigns-container" style={{marginTop:"15px"}}>
                        <EmployeeCampaigns policy_id={this.props.policy_id} />
                    </div>         
                </div>
            );
        } else {
            contents = (
                <div className='campaign-empty-state' style={{display:"flex",flexDirection:'column',alignItems:'center',paddingTop:60}}>
                    <div style={{opacity:0.2,marginBottom:20}}>
                        <MdEmail style={{fill: "rgb(100,120,140)", fontSize:80}}/>
                    </div>
                    <div style={{fontSize:"15px",fontWeight:500,marginBottom:20}}> Campaign is currently inactive for this benefit year.</div>
                </div>
            );
        }

        return (
            <div>
                {contents}
            </div>
        );
    }

    getCampaign =() => {
        fetch("/api/Flex/getpolicycampaign?PolicyId=" + this.props.policy_id, {
            method: "GET",
          })
        .then((response) => response.json())
        .then((data) => {
            if (data.success) {
                this.setState({
                    loading: false,
                    hasCampaign: true,
                    SelectionDeadline: data.campaign.selectionDeadline,
                    LaunchDate: data.campaign.launchDate,
                    ReminderDate: data.campaign.reminderDate,
                    LastDayReminder: data.campaign.lastDayReminder
                });
            }
            else {
                this.setState({
                    loading: false,
                    hasCampaign: false
                });
            }
        })
        .catch((error) => {
            toastr.error("Error getting campaign info");
            this.setState({
                loading: false,
                hasCampaign: false
            });
        });
    }
};
